import gql from 'graphql-tag';

export const GET_SIGN_IMAGE_CONTENTS = gql`
query($id: String!) {
  device(id: $id) {
    ... on Sign {
      image_contents
      sign_command {
        program
        program_state
        timestamp
      }
      blinking_lights {
        blinking_lights_command {
          program
          program_state
          timestamp
        }
      }
    }
  }
}
`;

export const SWITCH_PROGRAM = gql`
  mutation SwitchPrograms($programs: [SwitchProgramInput!], $cause: String!, $initiator: String!) {
    switchPrograms(programs: $programs, cause: $cause, initiator: $initiator)
  }
`;

export const RESET_RGB = gql `
  mutation ResetRGB($id: String!, $cause: String, $initiator: String){
    resetRGB(id: $id, cause: $cause, initiator: $initiator)
  }
`;

export const GET_SIGN_STATE = gql`
query($id: String!) {
  device(id: $id) {
    ... on Sign {
      sign_state {
        program
        program_state
        error_state
        timestamp
      }
      sign_command {
        program
        program_state
        timestamp
      }
      blinking_lights {
        blinking_lights_state {
          program
          program_state
          error_state
          timestamp
        }
        blinking_lights_command {
          program
          program_state
          timestamp
        }
      }
      ambient_brightness {
        brightness
        timestamp
      }
      door_contact_state {
        open
        timestamp
      }
      cluster {
        cluster_state {
          operating_mode
          brightness
          state
          timestamp
        }
        cluster_command {
          operating_mode
          brightness
          timestamp
        }
      }
    }
  }
}
`;
